import React from 'react'
import { Switch, Route } from 'react-router-dom'
import First from './components/homepage';
import Ourhistory from './components/ourhistory';
import Ourpillars from './components/ourpillars';
import Divisions from './components/divisions';
import Services from './components/services';
import Portfolio from './components/portifolio';
import ProjectDetails from './components/project-details';
import News from './components/news';
import Contactus from './components/contactus';


const App = () => {
return (
  <Switch>
    <Route exact path='/'>
    <First />
    </Route>
    <Route exact path='/aboutus'>
    <Ourhistory />
    </Route>
    <Route exact path='/management'>
    <Ourpillars />
    </Route>
    <Route exact path='/subsidiaries'>
    <Divisions />
    </Route>
    <Route exact path='/services'>
    <Services />
    </Route>
    <Route exact path='/portfolio'>
    <Portfolio />
    </Route>
    <Route exact path='/project-details'>
    <ProjectDetails />
    </Route>
    <Route exact path='/news&updates'>
    <News />
    </Route>
    <Route exact path='/contactus'>
    <Contactus />
    </Route>
</Switch>
)
}

export default App